import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SettingService {
  private readonly baseUrl = (environment.cncsCoreUrl ?? '').trim().replace(/\/+$/, '');
  private readonly cache = new Map<string, Observable<unknown>>();

  constructor(private readonly http: HttpClient) {}

  getSetting<T>(settingKey: string): Observable<T> {
    const key = String(settingKey).trim();

    if (key === '') {
      return of(undefined as T);
    }

    const cached = this.cache.get(key);
    if (cached) {
      return cached as Observable<T>;
    }

    const requestUrl = `${this.baseUrl}/api/setting/key/${encodeURIComponent(key)}`;
    const request = this.http.get<unknown>(requestUrl).pipe(
      map((response) => this.extractSettingValue(response) as T),
      catchError(() => of(undefined as T)),
      shareReplay(1),
    );

    this.cache.set(key, request as Observable<unknown>);
    return request;
  }

  private extractSettingValue(response: unknown): unknown {
    if (typeof response === 'object' && response !== null && !Array.isArray(response)) {
      const record = response as Record<string, unknown>;
      if (record['value'] !== undefined) {
        return record['value'];
      }
    }

    return response;
  }
}